import { Modal } from "@packages/ds";
import styled from "styled-components";

export const CustomContent = styled(Modal.Content)`
  padding: 0;
  top: 64px;
  width: 100%;
  height: calc(100% - 64px);
  background: var(--dark);
  box-shadow: none;
`;

export const CustomOverlay = styled(Modal.Overlay)`
  background-color: var(--night);
`;
